import React, { useEffect, useState } from "react";
import {
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
} from "reactstrap";
import { UL } from "../../../AbstractElements";
import SearchContainer from "./SearchContainer";
import Notification from "./Notification";
import CartHeader from "./CartHeader";
import MessageHeader from "./MessageHeader";
import MoonLight from "./MoonLight";
import ProfileHeader from "./ProfileHeader";
import BookmarkHeader from "./BookmarkHeader";
import MaximizeScreen from "./MaximizeScreen";
import LanguageSelect from "./LanguageSelect";
import DropdownCommon from "../../../Utils/CommonComponents/DropdownCommon";
import { ensureDexieReady, getDataFromDexie } from "../../../db/DexieServises";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux-toolkit/store";
import { setOrgUnit } from "../../../redux-toolkit/reducers/OrgUnitSlice";
import { setDateRange } from "../../../redux-toolkit/positionSlice";
import { useLocation, useNavigate } from "react-router-dom";
import TreeModelReport from "../../../Components/Dashboards/Attendance/AttendanceTable/TreeModelReport";
import { setOutletTypes } from "../../../redux-toolkit/reducers/OutletTypeSlice";
import { setOutletTypeNames } from "../../../redux-toolkit/reducers/OutletTypeNameSlice";
import { getData } from "../../../CommonElements/Functions/PostGetFun";
import { API } from "../../../api/API";

export default function RightHeader() {
  const dispatch = useDispatch();
   const navigate = useNavigate();
  const selectedOrgUnit = useSelector((state: RootState) => state.orgUnit);
  const location = useLocation();
  const monthRangeFromRedux = useSelector(
    (state: RootState) => state.position.dateRange
  );
  // console.log(monthRangeFromRedux,"==============monthdata============");
  
  const positions = useSelector((state: RootState) => state.position.positions);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [savedUnit, setSavedUnit] = useState<{
    UnitName?: string;
    Orgunitid?: string;
  }>({});
  const [orgUnits, setOrgUnits] = useState<
    { UnitName: string; Orgunitid: string }[]
  >([]);
  const [selectedTreeIds, setSelectedTreeIds] = useState<(string | number)[]>(
    []
  );
  const [monthRange, setMonthRange] = useState({
    from: { month: "", year: "" },
    to: { month: "", year: "" },
  });
  const [monthModalOpen, setMonthModalOpen] = useState(false);

  const monthNumberToName: { [key: number]: string } = {
    1: "Jan",
    2: "Feb",
    3: "Mar",
    4: "Apr",
    5: "May",
    6: "Jun",
    7: "Jul",
    8: "Aug",
    9: "Sep",
    10: "Oct",
    11: "Nov",
    12: "Dec",
  };
  // console.log(monthNumberToName, "==========   monthNumberToName ========");
  
  const monthToNumber: { [key: string]: number } = Object.fromEntries(
    Object.entries(monthNumberToName).map(([key, value]) => [
      value,
      parseInt(key),
    ])
  );
  console.log(monthToNumber,"======== monthNumberTo ===========");
  

  const yearOptions = Array.from(
    { length: 2 },
    (_, i) => new Date().getFullYear() - i
  );

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);
  const toggleMonthModal = () => setMonthModalOpen((prev: boolean) => !prev);

  useEffect(() => {
    const fetchOrgUnits = async () => {
      const tableName = "OrgUnit";
      const schemaJson = localStorage.getItem(`schema_${tableName}`);
      if (!schemaJson) {
        console.warn(`⚠️ No schema found for table: ${tableName}`);
        return;
      }

      try {
        await ensureDexieReady();

        const rawData = await getDataFromDexie(tableName);

        if (!rawData.length) {
          console.warn(`⚠️ Skipping ${tableName}: No data`);
          return;
        }

        const cleanedData = rawData.map((item: any) => ({
          UnitName: item.UnitName,
          Orgunitid: item.Orgunitid,
        }));

        setOrgUnits(cleanedData);

        // ✅ Only auto-select if no OrgUnit is currently set
        if (!selectedOrgUnit?.id && cleanedData.length > 0) {
          dispatch(
            setOrgUnit({
              id: cleanedData[0].Orgunitid,
              name: cleanedData[0].UnitName,
            })
          );
        }
      } catch (error) {
        console.error("Failed to fetch OrgUnit data", error);
      }
    };

    fetchOrgUnits();
  }, [dispatch, selectedOrgUnit?.id]);

  useEffect(() => {
    const fetchOrgUnitOutletTypes = async () => {
      const tableName = "OrgUnit";
      const schemaJson = localStorage.getItem(`schema_${tableName}`);
      if (!schemaJson) {
        console.warn(`⚠️ No schema found for table: ${tableName}`);
        return;
      }

      try {
        await ensureDexieReady();
        const rawData = await getDataFromDexie(tableName);

        if (!rawData.length) {
          console.warn(`⚠️ Skipping ${tableName}: No data`);
          return;
        }

        const primaryOutletType = rawData[0]?.PrimaryOutletType || null;
        const secondaryOutletType = rawData[0]?.SecondaryOutletType || null;
        const serverUrl = localStorage.getItem("serverUrl");
        const url = `${serverUrl}${API.getOutletTypes}`;

        try {
          const { status, data } = await getData(url, true);

          if (status === 200 && Array.isArray(data.data)) {
            const rawData = data.data;

            const primaryOutletTypeId = primaryOutletType;
            const secondaryOutletTypeId = secondaryOutletType;
            console.log("Primary Outlet Type IDvv:", primaryOutletTypeId);
            console.log("Secondary Outlet Type IDvv:", secondaryOutletTypeId);
            console.log("rawData Outlet Type ID:", rawData);
            console.log("rawData:", rawData);
            console.log("primaryOutletTypeId:", primaryOutletTypeId);
            console.log("secondaryOutletTypeId:", secondaryOutletTypeId);

            const primaryOutletName = rawData.find((item: { OutlettypeId: number }) => {
              return Number(item.OutlettypeId) === Number(primaryOutletTypeId);
            })?.OutlettypeName || null;

            const secondaryOutletName = rawData.find((item: { OutlettypeId: number }) => {
              return Number(item.OutlettypeId) === Number(secondaryOutletTypeId);
            })?.OutlettypeName || null;

            console.log("Primary Outlet Name:", primaryOutletName);
            console.log("Secondary Outlet Name:", secondaryOutletName);

            dispatch(
              setOutletTypeNames({
                primary: primaryOutletName,
                secondary: secondaryOutletName,
              })
            );
          }
        } catch (error) {
          console.error("Failed to fetch and match outlet types:", error);
        }
        dispatch(
          setOutletTypes({
            primary: primaryOutletType,
            secondary: secondaryOutletType,
          })
        );
      } catch (error) {
        console.error("Failed to fetch OrgUnit outlet types:", error);
      }
    };
    const fetchAndMatchOutletTypes = async () => {};

    fetchAndMatchOutletTypes();

    fetchOrgUnitOutletTypes();
  }, [dispatch]);

  useEffect(() => {}, [dispatch]);

  const handleSelect = (unit: { UnitName: string; Orgunitid: string }) => {
    dispatch(setOrgUnit({ id: unit.Orgunitid, name: unit.UnitName }));
    // navigate('/activities');
    setTimeout(() => setDropdownOpen(false), 0); // Ensure dropdown closes after value change
  };

  const handleApplyDateRange = () => {
    if (monthRange.from.month && monthRange.to.month) {
      dispatch(
        setDateRange({
          start: `${monthToNumber[monthRange.from.month]}-${
            monthRange.from.year
          }`,
          end: `${monthToNumber[monthRange.to.month]}-${monthRange.to.year}`,
        })
      );
      toggleMonthModal();
    }
  };
const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth() + 1; // Jan = 1
  const containerWidth = positions.length > 0 ? "220px" : "50px";

  return (
    <Col className="d-flex justify-content-end align-items-center">
      <UL className="nav-menus simple-list flex-row">
        {/* <SearchContainer/> */}
        {/* <MaximizeScreen/> */}
        {/* <Notification/> */}
        {/* <LanguageSelect/> */}
        {/* <BookmarkHeader/> */}
        {/* <CartHeader/> */}
        {/* <MessageHeader/> */}
        {/* <MoonLight /> */}
        {location.pathname === "/activities" && (
          <>
            <div
              className="me-3"
              style={{
                width: containerWidth,
                marginRight: "20px",
                marginTop: "7px",
              }}
            >
              {/* Adjusted width dynamically based on positions length */}
              <TreeModelReport onSelectionChange={setSelectedTreeIds} />
            </div>
            <div
              className="d-flex align-items-center"
              style={{ width: "220px" }}
            >
              {" "}
              {/* Added marginLeft for spacing */}
              <Button color="info" onClick={toggleMonthModal} className="me-3">
                {monthRangeFromRedux.start && monthRangeFromRedux.end
                  ? `${
                      monthNumberToName[
                        parseInt(monthRangeFromRedux.start.split("-")[0], 10)
                      ]
                    } ${monthRangeFromRedux.start.split("-")[1]} - ${
                      monthNumberToName[
                        parseInt(monthRangeFromRedux.end.split("-")[0], 10)
                      ]
                    } ${monthRangeFromRedux.end.split("-")[1]}`
                  : monthRange.from.month && monthRange.to.month
                  ? `${monthRange.from.month} ${monthRange.from.year} - ${monthRange.to.month} ${monthRange.to.year}`
                  : "Select Month Range"}
              </Button>
            </div>

            <Modal isOpen={monthModalOpen} toggle={toggleMonthModal} centered>
              <ModalHeader toggle={toggleMonthModal}>
                Select Month Range
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Col md={6}>
                    <label>From</label>
                    <select
                      className="form-control"
                      value={`${monthRange.from.month}-${monthRange.from.year}`}
                      onChange={(e) => {
                        const [month, year] = e.target.value.split("-");
                        setMonthRange({ ...monthRange, from: { month, year } });
                      }}
                    >
                      <option value="">Select Month</option>
                      {yearOptions.flatMap((year) =>
                        Object.entries(monthNumberToName)
                          .sort(([a], [b]) => Number(b) - Number(a)) // Desc months
                          .filter(([monthNumber]) => {
                            if (year === currentYear) {
                              return Number(monthNumber) <= currentMonth; // hide future months
                            }
                            return true;
                          })
                          .map(([_, monthName]) => (
                            <option
                              key={`${monthName}-${year}`}
                              value={`${monthName}-${year}`}
                            >
                              {`${monthName}-${year}`}
                            </option>
                          ))
                      )}

                    </select>
                  </Col>
                  <Col md={6}>
                    <label>To</label>
                    <select
                      className="form-control"
                      value={`${monthRange.to.month}-${monthRange.to.year}`}
                      onChange={(e) => {
                        const [month, year] = e.target.value.split("-");
                        setMonthRange({ ...monthRange, to: { month, year } });
                      }}
                    >
                      <option value="">Select Month</option>
                      {yearOptions.flatMap((year) =>
                      Object.entries(monthNumberToName)
                        .sort(([a], [b]) => Number(b) - Number(a)) // Desc months
                        .filter(([monthNumber]) => {
                          if (year === currentYear) {
                            return Number(monthNumber) <= currentMonth; // hide future months
                          }
                          return true;
                        })
                        .map(([_, monthName]) => (
                          <option
                            key={`${monthName}-${year}`}
                            value={`${monthName}-${year}`}
                          >
                            {`${monthName}-${year}`}
                          </option>
                        ))
                    )}

                    </select>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={toggleMonthModal}>
                  Cancel
                </Button>
                <Button
                  color="danger"
                  onClick={() => {
                    setMonthRange({ from: { month: "", year: "" }, to: { month: "", year: "" } });
                    dispatch(setDateRange({ start: "", end: "" }));
                    toggleMonthModal();
                  }}
                >
                  Clear
                </Button>
                <Button color="success" onClick={handleApplyDateRange}>
                  Apply
                </Button>
              </ModalFooter>
            </Modal>
          </>
        )}
        <li>
          <div className="m-2 me-4">
            <Dropdown
              isOpen={dropdownOpen}
              toggle={toggleDropdown}
              className="dropdown-container"
              style={{ display: "inline-block" }}
            >
              <DropdownToggle
                caret
                color="primary"
                className="d-flex justify-content-between align-items-center"
                style={{
                  width: "auto",
                  minWidth: "calc(100% + 10px)", // optional fallback
                  paddingLeft: "16px",
                  paddingRight: "16px",
                  whiteSpace: "nowrap",
                }}
              >
                <span>{selectedOrgUnit.name || "Org Unit"}</span>
              </DropdownToggle>
              <DropdownMenu>
                {orgUnits.map((unit) => (
                  <DropdownItem
                    key={unit.Orgunitid}
                    onClick={() => handleSelect(unit)}
                    className="dropdown-item-custom"
                  >
                    {unit.UnitName}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
        </li>

        <ProfileHeader />
      </UL>
    </Col>
  );
}
